module.exports = __webpack_public_path__ + "static/img/vue.eb59945b.png";